// PublisherLayout.tsx
import React, { ReactNode } from 'react';
import PublisherSidebar from './components/PublisherSidebar';
import PublisherHeader from './components/PublisherHeader';

interface LayoutProps {
  children: ReactNode;
}

const PublisherLayout: React.FC<LayoutProps> = ({ children }) => (
  <div className='flex h-screen bg-gray-100'>
    <PublisherSidebar />

    <div className='flex flex-col flex-1 w-full min-w-0'>
      {/* <PublisherHeader /> */}
      <main className='p-4 lg:p-6 xl:p-8 2xl:p-10 flex-1 overflow-y-auto'>
        {children}
      </main>
    </div>
  </div>
);

export default PublisherLayout;
